import OrbitHoverDetails from "./orbit-hover-details";

export default OrbitHoverDetails